export default "__VITE_ASSET__WnSK$Bkw__"